module.exports = __webpack_public_path__ + "media/images/linkedin@2x-3cd687675fbdd4c7c8fb6d5b37d0a0c4.png";